import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var ShippingBoxIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M27.6383 9.27591L30.2854 16.0917L32.9326 9.27591C33.2314 8.50675 33.9718 8 34.797 8H43.0773C44.4837 8 45.4508 9.41314 44.9416 10.7241L41.9998 18.2984V37.5C41.9998 38.8807 40.8805 40 39.4998 40L9.21416 40C7.83345 40 6.71416 38.8807 6.71416 37.5V20.1379L3.32236 11.4051C2.68591 9.76642 3.89481 8 5.65276 8H25.7739C26.5991 8 27.3395 8.50675 27.6383 9.27591ZM5.65276 10.5H25.4317L28.2041 17.6379H8.42508L5.65276 10.5ZM31.7142 20.1379V37.5L39.4998 37.5V20.1379H31.7142ZM35.1392 10.5H42.3467L39.5891 17.6H32.3816L35.1392 10.5ZM28.9998 20.1858H9.21416V37.5H28.9998V20.1858Z",
    fillRule: "evenodd"
  }));
});
ShippingBoxIcon.displayName = 'ShippingBoxIcon';
ShippingBoxIcon.defaultProps = {
  'aria-label': 'Shipping Box'
};
export default ShippingBoxIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/ShippingBoxIcon/index.js
// module id = 1943
// module chunks = 12